import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanCommunicationStore } from '../stores/loanCommunicationStore';

export const useLoanCommunicationStore = () => useContext<{
  loanCommunicationStore: LoanCommunicationStore
}>(StoreContext);
